<template>
  <TransactionHistory />
</template>

<script>
import TransactionHistory from "@/views/transaction/TransactionHistory.vue";

export default {
  name: "WalletView",
  components: {
    TransactionHistory,
  },
};
</script>
